import React from 'react';
import { 
  // FaUserTie, 
  FaBolt, 
  FaWrench, 
  FaTint, 
  FaUsersCog, 
  FaUtensils,
  FaPaintRoller,
  FaHammer,
  FaHome
} from 'react-icons/fa';

export const allServices = [
  { icon: <FaTint />, name: 'Water Purifier' },
  { icon: <FaUtensils />, name: 'OYO-Kitchen' },
  // { icon: <FaUserTie />, name: 'Maid' },
  { icon: <FaBolt />, name: 'Electrician' },
  { icon: <FaWrench />, name: 'Plumber' },
  { icon: <FaUsersCog />, name: 'Workers' },
  { icon: <FaPaintRoller />, name: 'Painting' },
  { icon: <FaHammer />, name: 'Carpenter' },
  { icon: <FaHome />, name: 'House Rental' },
];

export const subServices = {
  'Water Purifier': [
    { name: 'Installation', icon: '💧' },
    { name: 'Repair & Maintenance', icon: '🛠️' },
    { name: 'Filter Replacement', icon: '🔄' }
  ],
  'OYO-Kitchen': [
    { name: 'Festival Special', icon: '🍱' },
    { name: 'Traditional Sweets', icon: '🍬' },
    { name: 'Snacks & Savories', icon: '🥟' },
    { name: 'Custom Orders', icon: '📦' }
  ],
  // Maid: [
  //   { name: 'Bathroom Cleaning', icon: '🛁' },
  //   { name: 'Kitchen Cleaning', icon: '🍳' },
  //   { name: 'Full Home Cleaning', icon: '🏠' },
  //   { name: 'Sofa & Carpet Cleaning', icon: '🛋️' }
  // ],
  Electrician: [
    { name: 'Fan Repair', icon: '🌀' },
    { name: 'Switch Board Install', icon: '🔌' },
    { name: 'Wiring', icon: '🧵' },
    { name: 'Appliance Repair', icon: '🖥️' }
  ],
  Plumber: [
    { name: 'Leak Fix', icon: '🚰' },
    { name: 'Tap Installation', icon: '🚿' },
    { name: 'Drainage Cleaning', icon: '🧹' },
    { name: 'Bathroom Fittings', icon: '🛠️' }
  ],
  Workers: [
    { name: 'Daily Labor', icon: '🧱' },
    { name: 'Loader', icon: '📦' },
    { name: 'House Shifting', icon: '🚚' }
  ],
  Painting: [
    { name: 'Interior Painting', icon: '🎨' },
    { name: 'Exterior Painting', icon: '🏡' },
    { name: 'Wall Texture & Design', icon: '🖌️' },
    { name: 'Waterproof Coating', icon: '💦' }
  ],
  Carpenter: [
    { name: 'Furniture Repair', icon: '🪑' },
    { name: 'Custom Furniture', icon: '📐' },
    { name: 'Door & Window Repair', icon: '🚪' },
    { name: 'Wood Polishing', icon: '✨' }
  ],
  'House Rental': [
    { name: '1BHK Rental', icon: '🏠' },
    { name: '2BHK Rental', icon: '🏡' },
    { name: '3BHK Rental', icon: '🏘️' },
    { name: 'PG / Shared Rooms', icon: '🛏️' },
    { name: 'Commercial Spaces', icon: '🏢' }
  ]
};

export const serviceRoutes = {
  'Festival Special': '/festival-thali',
  'Traditional Sweets': '/traditionalsweets',
  'Snacks & Savories': '/snacks',
  'Custom Orders': '/Customorder',
  'Bathroom Cleaning': '/bathroom-cleaning',
  'Kitchen Cleaning': '/kitchen-cleaning',
  'Full Home Cleaning': '/full-home-cleaning',
  'Sofa & Carpet Cleaning': '/sofa-carpet-cleaning',
  'Fan Repair': '/fan-repair',
  'Switch Board Install': '/switch-board-install',
  'Wiring': '/wiring',
  'Appliance Repair': '/appliance-repair',
  'Leak Fix': '/leak-fix',
  'Tap Installation': '/tap-installation',
  'Drainage Cleaning': '/drainage-cleaning',
  'Bathroom Fittings': '/bathroom-fittings',
  'Installation': '/water-purifier-installation',
  'Repair & Maintenance': '/water-purifier-repair',
  'Filter Replacement': '/water-purifier-filter-replacement',
  'Daily Labor': '/daily-labor',
  'Loader': '/loader',
  'House Shifting': '/house-shifting',

  // Painting
  'Interior Painting': '/interior-painting',
  'Exterior Painting': '/exterior-painting',
  'Wall Texture & Design': '/wall-texture-design',
  'Waterproof Coating': '/waterproof-coating',

  // Carpenter
  'Furniture Repair': '/furniture-repair',
  'Custom Furniture': '/custom-furniture',
  'Door & Window Repair': '/door-window-repair',
  'Wood Polishing': '/wood-polishing',

  // House Rental
  '1BHK Rental': '/1bhk-rental',
  '2BHK Rental': '/2bhk-rental',
  '3BHK Rental': '/3bhk-rental',
  'PG / Shared Rooms': '/pg-shared-rooms',
  'Commercial Spaces': '/commercial-spaces'
};
